import { render } from "./componentNumber.vue?vue&type=template&id=140ea22f"
import script from "./componentNumber.vue?vue&type=script&lang=js"
export * from "./componentNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__